import React from "react";

export function InfoItem({ text }) {
  const checkIcon = `<svg width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg" class="info-icon" style="width: 32px; height: 33px; position: relative"> <g clip-path="url(#clip0_66_718)"> <path d="M14.6994 33.3982C7.30338 32.5842 1.58258 27.022 0.636709 19.6962C-0.559872 10.4599 6.30053 2.47836 15.2008 1.75483C15.9074 1.6983 16.5341 2.25226 16.5341 2.95318C16.5341 3.56367 16.0669 4.09501 15.4515 4.14023C8.49996 4.68288 2.99568 10.4486 2.92731 17.4691C2.85893 24.4897 8.97859 30.8093 15.9871 31.0806C23.3718 31.3633 29.5256 25.7898 30.084 18.6675C30.1296 18.057 30.6652 17.5935 31.2806 17.5935C31.9985 17.5935 32.5455 18.204 32.4886 18.9162C31.7592 27.6551 23.8846 34.4157 14.688 33.3982H14.6994Z" fill="#616E7D"></path> <path d="M17.047 23.5174C16.7849 23.9018 16.2151 23.8905 15.9644 23.4948L9.79915 13.7158C9.44587 13.1505 9.61681 12.4157 10.1866 12.0652C10.7564 11.7148 11.4972 11.8844 11.8504 12.4496L16.557 19.9224L29.4117 1.03132C29.7878 0.477366 30.5399 0.330398 31.0983 0.703471C31.6567 1.07654 31.7934 1.82269 31.4288 2.37665L17.047 23.5174Z" fill="#82BFAB"></path> </g> <defs> <clipPath id="clip0_66_718"> <rect width="32" height="33" fill="white" transform="translate(0.5 0.5)"></rect> </clipPath> </defs> </svg>`;

  return (
    <div className="d-flex align-items-center gap-3">
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: checkIcon,
          }}
        />
      </div>
      <p className="mb-0 text-muted">
        {text}
      </p>
    </div>
  );
}
